import React from 'react'
import SignupContext from 'modules/react/signup/SignupContext'

export default function RightContentEmployee () {

  const { employee } = React.useContext(SignupContext)

  if (!employee) {
    return null
  }

  return (
    <div className="sidebar-employee">
      <div className="sidebar-employee__title title title--h7">{employee.title}</div>
      <div className="sidebar-employee__wrap">
        <div className="sidebar-employee__image object-fit">
          <img src={employee.image.url} alt={employee.image.alt}/>
        </div>
        <div className="sidebar-employee__text-container">
          <div className="sidebar-employee__name tagline tagline--small tagline--prim">{employee.name}</div>
          <div className="sidebar-employee__phone">
            <a href={'tel:' + employee.phone.replaceAll(' ', '')}>{employee.phone}</a>
          </div>
        </div>
      </div>
    </div>
  )
}